var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("← Back")]),_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("EMM AI Logs Dashboard")]),_c('iframe',{attrs:{"src":"/grafana/d/249b1c3e-f16c-4303-90aa-08b68c4d1fa9/openai-usage-overview?orgId=1&kiosk","width":"100%","height":"800","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }